import React from 'react';
import {Link, graphql} from 'gatsby';

import Bio from '../components/bio';
import Layout from '../components/layout';
import SEO from '../components/seo';

class BlogIndex extends React.Component {
  render() {
    const {data} = this.props;
    const siteTitle = data.site.siteMetadata.title;
    const posts = data.allMarkdownRemark.edges;

    return (
      <Layout location={this.props.location} title={siteTitle}>
        <SEO title="All posts" keywords={[`blog`, `kroepfl`, `lukas`, `kröpfl lukas`, `lukas kröpfl`, `kröpfl`]} />
        <Bio />
        {posts.map(({node}) => {
          const title = node.frontmatter.title || node.fields.slug;
          return (
            <React.Fragment>
              <hr style={{marginBottom: '0'}} />
              <div key={node.fields.slug}>
                <h2
                  style={{
                    marginTop: '1em',
                    marginBottom: '0.2em'
                  }}>
                  <Link style={{boxShadow: `none`}} to={node.fields.slug}>
                    {title}
                  </Link>
                </h2>
                <small>
                  {node.frontmatter.date}, tags:{' '}
                  {node.frontmatter.tags.map(tag => (
                    <Link to={`/tags/${tag}`} style={{marginRight: '0.5em'}}>
                      {tag}
                    </Link>
                  ))}
                </small>
                <p
                  dangerouslySetInnerHTML={{
                    __html: node.frontmatter.description || node.excerpt
                  }}
                />
              </div>
            </React.Fragment>
          );
        })}
      </Layout>
    );
  }
}

export default BlogIndex;

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      filter: {fileAbsolutePath: {regex: "/content/posts/"}, fields: {draft: {eq: false}}}
      sort: {fields: [frontmatter___date], order: DESC}
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            title
            description
            tags
          }
        }
      }
    }
  }
`;
